import React, { useEffect } from "react";

export default function HelpCenter() {
  useEffect(() => {
    document.title = "ศูนย์ช่วยเหลือ - ChicChic";
  }, []);

  return (
    <div className="content-container">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <h1 className="mb-3">ศูนย์ช่วยเหลือ</h1>
            <p className="text-muted mb-4">
              รวมวิธีแก้ไขปัญหาการใช้งานเบื้องต้น เช่น วิดีโอไม่แสดงผล หรือหน้าเรียนโหลดช้า
            </p>

            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">1. วิดีโอไม่แสดงผล / ช่องวิดีโอว่าง / ขึ้นข้อความผิดพลาด</h2>
                <p>
                  หากเข้าสู่หน้าเรียนได้ตามปกติ แต่ส่วนวิดีโอไม่แสดงผล อาจเกิดจากเบราว์เซอร์
                  อินเทอร์เน็ต อุปกรณ์ หรือการตั้งค่าบางอย่างในเครื่องของผู้ใช้งาน
                </p>

                <h3 className="h6 mt-4">วิธีแก้ไขเบื้องต้น</h3>
                <ol>
                  <li>กดรีเฟรชหน้าเว็บ 1 ครั้ง</li>
                  <li>ปิด Safari / Chrome แล้วเปิดเข้าเว็บใหม่</li>
                  <li>ลองเปลี่ยนเบราว์เซอร์ เช่น Chrome, Safari หรือ Edge</li>
                  <li>ลองเปลี่ยนอินเทอร์เน็ต เช่น Wi-Fi เป็น 4G/5G หรือ Hotspot</li>
                  <li>ปิด Ad Blocker / Content Blocker ชั่วคราว</li>
                  <li>ปิด VPN หรือ iCloud Private Relay หากเปิดใช้งานอยู่</li>
                  <li>Restart อุปกรณ์ แล้วลองเข้าใหม่อีกครั้ง</li>
                </ol>

                <p className="mb-0">
                  หากใช้ iPhone หรือ iPad รุ่นเก่า แนะนำให้อัปเดต iOS/iPadOS ให้เป็นเวอร์ชันล่าสุด
                  ที่อุปกรณ์รองรับ และลองล้างประวัติ Safari หากยังพบปัญหา
                </p>
              </div>
            </div>

            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">2. วิธีปิด Safari แล้วเปิดใหม่บน iPhone / iPad</h2>
                <ol>
                  <li>ปัดขึ้นจากขอบล่างจอแล้วค้างไว้ หรือกดปุ่ม Home สองครั้งในรุ่นเก่า</li>
                  <li>จะเห็นหน้ารวมแอปที่เปิดค้างอยู่</li>
                  <li>หา Safari แล้วปัดขึ้นด้านบนเพื่อปิดแอป</li>
                  <li>เปิด Safari ใหม่ แล้วเข้าเว็บอีกครั้ง</li>
                </ol>
                <p className="mb-0">
                  วิธีนี้ช่วยแก้ปัญหาวิดีโอค้าง หรือ player โหลดไม่สมบูรณ์ได้บ่อย
                </p>
              </div>
            </div>

            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">3. วิธีล้างประวัติ Safari</h2>
                <ol>
                  <li>เปิดแอป Settings / การตั้งค่า</li>
                  <li>เลือก Safari</li>
                  <li>เลือก Clear History and Website Data / ล้างประวัติและข้อมูลเว็บไซต์</li>
                  <li>กลับมาเปิดเว็บไซต์และเข้าสู่ระบบใหม่อีกครั้ง</li>
                </ol>
                <p className="mb-0">
                  วิธีนี้เหมาะสำหรับกรณีวิดีโอไม่ขึ้นซ้ำ ๆ หรือ Safari จำข้อมูลเก่าไว้
                </p>
              </div>
            </div>

            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">4. หน้าเรียนโหลดช้า / ขึ้นว่ากำลังโหลดคอร์สนาน</h2>
                <p>
                  หากหน้าเรียนโหลดนาน อาจเกิดจากอินเทอร์เน็ตชั่วคราว เบราว์เซอร์ค้าง
                  หรือการเชื่อมต่อกับระบบวิดีโอและข้อมูลคอร์สไม่สมบูรณ์
                </p>

                <h3 className="h6 mt-4">แนะนำให้ลองตามลำดับ</h3>
                <ol>
                  <li>รีเฟรชหน้าเว็บ</li>
                  <li>ปิดเบราว์เซอร์แล้วเปิดใหม่</li>
                  <li>ลองเข้าใหม่ในอีก 1-2 นาที</li>
                  <li>สลับอินเทอร์เน็ต เช่น Wi-Fi เป็น 4G/5G</li>
                  <li>Restart Router หากใช้ Wi-Fi บ้านหรือ Wi-Fi หน่วยงาน</li>
                  <li>ลองเปิดจากอุปกรณ์อื่น เช่น มือถือหรือคอมพิวเตอร์</li>
                  <li>ล้าง cache/history ของเบราว์เซอร์</li>
                </ol>
              </div>
            </div>

            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">5. กรณีใช้อินเทอร์เน็ตของหน่วยงาน</h2>
                <p>
                  หากใช้อินเทอร์เน็ตของหน่วยงานราชการ องค์กร หรือโรงเรียน
                  บางแห่งอาจมีระบบ Firewall, Proxy หรือระบบกรองเว็บไซต์
                  ทำให้บางส่วนของวิดีโอไม่สามารถโหลดได้
                </p>
                <p className="mb-0">
                  แนะนำให้ลองใช้อินเทอร์เน็ตส่วนตัว เช่น 4G/5G หรือ Hotspot
                  หากใช้งานได้ แสดงว่าเครือข่ายเดิมอาจมีข้อจำกัดบางอย่าง
                </p>
              </div>
            </div>

            <div className="card border">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">6. หากยังใช้งานไม่ได้</h2>
                <p>
                  หากลองตามขั้นตอนข้างต้นแล้วยังพบปัญหา กรุณาติดต่อแอดมิน
                  พร้อมแนบข้อมูลต่อไปนี้ เพื่อให้ตรวจสอบได้รวดเร็วขึ้น
                </p>
                <ul>
                  <li>ภาพหน้าจอปัญหาที่พบ</li>
                  <li>ชื่อคอร์สและชื่อบทเรียนที่เปิดดู</li>
                  <li>อุปกรณ์ที่ใช้ เช่น iPhone, iPad, Android, คอมพิวเตอร์</li>
                  <li>เบราว์เซอร์ที่ใช้ เช่น Safari, Chrome, Edge</li>
                  <li>ใช้อินเทอร์เน็ตแบบ Wi-Fi, 4G/5G, Hotspot หรืออินเทอร์เน็ตหน่วยงาน</li>
                </ul>
                <p className="mb-0">
                  ติดต่อเราได้ที่ <a href="https://web.facebook.com/lawlandd/about?_rdc=1&_rdr#" target="_blank" rel="noreferrer">ติดต่อเรา</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}